<div id="wrap" *ngIf="survey.type==1">
  <div class="headTitle fontSize21" [ngStyle]="{'font-size': isHarmonyOS ? '21px' : '', 'line-height': isHarmonyOS ? '55px' : '1.1rem'}"> <span id="closeBtn"  class="common-back-btn-dark" (click)="showTip2()" *ngIf="abilityBack&&isOpenClass===0&&isShowBackBtn"></span>领导力DNA测验</div>
  <ul class="dnaTestIllustrate">
    <li class="dnaTestIllustrateTop" [ngStyle]="{'font-size': isHarmonyOS ? '16px' : '', 'line-height': isHarmonyOS ? '26px' : ''}">
      <img src="{{assetsRoute}}/picture/reportnew/model.png" alt="">
      <p>“什么？外向的人更容易成为领袖？”<br />“异想天开=做事不靠谱？”<br/>对，也不对！</p>
      <p>DDI研究证明，个性特质和领导力密切相关，甚至决定了你领导力的发展方向和速度。但是，两者的关系并不像外界所说的那么简单。</p>
      <p>想知道你的个性究竟怎样影响着领导力，如何才能扬长避短吗？领导力DNA测验就将为你开启性格密码的解密之门，带你一窥究竟！</p>
    </li>
    <!--<li class="dnaTestIllustrateBottom">-->
      <!--<p>本次测验大概需要<span class="light-blue"><b>10-20</b></span>分钟</p>-->
        <!--<p>测试环境会影响你的发挥，<br/>建议在比较安静的环境中作答。</p>-->
    <!--</li>-->
  </ul>

  <img class="topArrow" src="{{assetsRoute}}/picture/reportnew/arrow.png" alt="" >
</div>

<div id="closeBtn" *ngIf="survey.type!=1" class="common-back-btn-dark" (click)="showTip2()">
  <span>×</span>
</div>

<div *ngIf="survey.type==2">

  <div class="title fontSize32">
    能力诊断
  </div>
  <div class="context fontSize16">
    <p>欢迎进入能力诊断，请根据情境选出你认为最佳的答案，完成后你将获得能力详细解读报告。</p>
    <p *ngIf="learningPathId!='not'">本测试计时20分钟。</p>
    <p *ngIf="learningPathId=='not'">本测验用时约1小时。</p>
    <p>能力报告一旦生成无法改变，所以请在保证质量的情况下尽快作答。</p>
  </div>

</div>

<div *ngIf="survey.type==3">
  <div class="title fontSize32">
    能力考核
  </div>
  <div class="context fontSize16">
    <p>收获你的成长！</p>
    <p>完成测验，你将获得成长报告（前后成绩对比）和发展建议。</p>
    <p>能力等级5及以上你将获得学习勋章，顺利完成旅程。</p>
  </div>
</div>


<!--<div id="button">
  <div id="button_bottom">
  <div id="wenzi">滑动开启测验</div>
  <div id="button_top"></div>
  </div>
</div> -->

<div [ngClass]="{'dnaPoisiton':survey.type==1,'abilityTestPosition':survey.type!=1}" *ngIf="survey.type!=1">
  <app-slide-button (onBegin)="begin();"></app-slide-button>
</div>



<div id="backgroundPicture" [ngClass]="{'hide':survey.type!==1}"></div>


<div id="shade" *ngIf="finishedNumber > 0"></div>

<div id="tip" *ngIf="finishedNumber > 0" [ngStyle]="{'font-size': isHarmonyOS ? '16px' : ''}">
  <p>之前的测验已完成了{{finishedNumber}}题，要继续吗？</p>

  <button id="restartBtn" class="btnWord" (click)="restart()">重新开始</button>
  <button id="continueBtn" class="btnWord" (click)="continue()">继续测验</button>
</div>

<div id="shade2"></div>
<div id="tip2">
  <p class="fontSize16" id="tip2Text">完成测验，可以了解你的个性倾向哦！</p>

  <button id="quitBtn" class="btnWord" (click)="close()">现在退出</button>
  <button id="beginBtn" class="btnWord" (click)="begin()">开始测验</button>
</div>



// WEBPACK FOOTER //
// ./src/app/begin/begin.component.html